import { defineComponent, h, PropType, toRaw } from 'vue';
import { FormText } from '@components/form';
import './SearchSelect.scss';

export default <T>() => defineComponent({
    props: {
        search: {
            required: true,
            type: String,
        },

        items: {
            required: true,
            type: null as any as PropType<T[]>,
        },

        selected: {
            required: true,
            type: null as any as PropType<undefined | T>,
        },

        placeholder: {
            required: false,
            type: String,
            default: 'Search...',
        },

        label: {
            required: true,
            type: String,
        },
    },

    emits: {
        'update:search': (x: string) => true,
        'update:selected': (x: T) => true,
        'scrolledToLast': () => true,
    },

    methods: {
        onClick(x: T) {
            this.$emit('update:selected', x);
        },

        setup_intersection_observer() {
            this.observer.disconnect();
            this.observer.observe(this.last_article());
        },

        onhit(entries: IntersectionObserverEntry[]) {
            for (const x of entries)
                if (x.isIntersecting) {
                    this.$emit('scrolledToLast');
                    this.observer.unobserve(x.target);
                    break;
                }
        },

        last_article(): HTMLDivElement {
            return this.$el.querySelector('.body > article:last-child');
        },
    },

    data() {
        return {
            observer: new IntersectionObserver(this.onhit as any),
        };
    },

    mounted() {
        this.setup_intersection_observer();
    },

    updated() {
        this.setup_intersection_observer();
    },

    render() {
        const renderer = this.$slots.item
            ? this.$slots.item
            : (x: T) => typeof x === 'string' ? x : '' + x;

        return h('div', {
            class: 'search-select',
        }, [
            h('label', this.label),

            h('header', [
                h(FormText, {
                    value: this.search,
                    'onUpdate:value': x => this.$emit('update:search', x),
                    placeholder: this.placeholder,
                }),

                this.$slots.header
                    ? this.$slots.header()
                    : '',
            ]),

            h('div', {
                class: {
                    body: true,
                    disabled: this.items.length === 0,
                }
            }, this.items.map(x => h(
                'article',
                {
                    onClick: () => this.onClick(x),
                    class: {
                        selected: x === this.selected || x === toRaw(this.selected)
                    },
                },
                renderer(x)
            ))),
        ]);
    },
});
